import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Navbar';
import { Container, ListGroup, Row } from "react-bootstrap";

import './css/SundaySchool.css';

function SundaySchool() {

    return (
        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>

            <div>
                <h4 className="label display-6">Sunday School</h4>
                <hr />
                <h4>Sunday school web page is being built.................</h4>

            </div>
        </div>
    )
}
export default SundaySchool;